import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainAgitation() {
  const pains = ['El domingo a las 23:00 estás juntando apuntes de 6 compañeros distintos que no coinciden entre sí. Y mañana tenés parcial de Fisiología del Movimiento.', 'Llegás a tu primera práctica hospitalaria y no sabés cómo arrancar la evaluación kinésica frente al paciente. El médico te mira. El paciente te mira. Y vos no sabés qué hacer primero.', 'Estudiás horas y horas pero en el examen se te va todo porque nunca tuviste el contenido ordenado de una forma que tenga sentido clínico real.', 'Buscás los parámetros de ultrasonido o los grados de movilidad articular en 5 lugares distintos y cada fuente te da un dato diferente. ¿A cuál le creés?', 'Estás en 4to año y todavía no entendés cómo se conectan Biomecánica, Clínica y Agentes Físicos entre sí. La carrera se siente como piezas sueltas que nunca encajan.', 'Llegás a las prácticas hospitalarias con miedo real de cometer un error frente a un paciente crítico. Nadie te enseñó qué hacer cuando algo sale mal en sala.'];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-262">
      <div className="max-w-5xl mx-auto" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-264">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-265">
            ¿Te sentís identificado?
          </h2>
          <p className="text-xl text-slate-700 max-w-3xl mx-auto" data-id="element-266">
            Esto le pasa al 90% de los estudiantes de Kinesiología en Argentina.
            No es falta de inteligencia. Es falta de un sistema de estudio real.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-267">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex gap-4 items-start bg-red-50 border border-red-200 p-4 md:p-6 rounded-lg" data-id="element-268">
              <XCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-269" />
              <p className="text-slate-700 leading-relaxed" data-id="element-270">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-271">
          <p className="text-2xl md:text-3xl font-bold text-slate-900" data-id="element-272">
            ¿Cuántos parciales más vas a improvisar? ¿Cuántas prácticas más vas
            a enfrentar sin el sistema que necesitás?
          </p>
        </motion.div>
      </div>
    </section>;
}